<template>
    <v-container fluid px-3 pt-3>
        <v-row row wrap>
            <v-col cols="12">
                <h3>Order Certificates</h3>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <button class="text-only" style="color:blue; font-size:x-large;" @click="redirectToBirth()">Order Birth Certificate </button><v-icon large @click="redirectToBirth()">mdi-baby-buggy</v-icon><br>
                <b>REQUESTS — WHO MAY HAVE COPIES:<v-icon @click="showBirthDiv = !showBirthDiv">mdi-chevron-down</v-icon></b>
                <div v-if="showBirthDiv">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                Vital records are considered confidential information and closed to the general public until one hundred (100) years after the date of birth or fifty (50) years after the date of marriage, divorce, or death. Generally, only those listed on the record are entitled to receive certified copies, though there are exceptions. Please refer to our website for more information on possible exceptions.
                                Individuals entitled to received certified copies of vital records are as follows:
                            </v-col>
                            <v-col cols="12">
                                <ul>
                                    <li>Registrant (child names on record), if of legal age (18 years or older)</li>
                                    <li>Either parent named on the certificate</li>
                                    <li>Lawyer representing either the registrant or the parent(s)*</li>
                                    <li>Legal guardian with certified copy of the guardianship papers (obtained from a Court)*</li>
                                    <li>Unemancipated Minor with signed affidavit</li>
                                </ul>
                            </v-col>
                            <v-col cols="12">
                                <i>* The applicant must demonstrate the requirement for the certificate</i>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </v-col>
            <v-divider></v-divider>
            <v-col cols="12">
                <button class="text-only" style="color:blue; font-size:x-large;" @click="redirectToDeath()">Order Death Certificate </button><v-icon large @click="redirectToDeath()">mdi-certificate</v-icon><br>
                <b>REQUESTS — WHO MAY HAVE COPIES:<v-icon @click="showDeathDiv = !showDeathDiv">mdi-chevron-down</v-icon></b>
                <div v-if="showDeathDiv">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                Vital records are considered confidential information and closed to the general public until one hundred (100) years after the date of birth or fifty (50) years after the date of marriage, divorce, or death. Generally, only those listed on the record are entitled to receive certified copies, though there are exceptions. Please refer to our website for more information on possible exceptions.
                                Individuals entitled to received certified copies of vital records are as follows:
                            </v-col>
                            <v-col cols="4">
                                <ul>
                                    <li>Immediate family members (parent, current spouse, child)</li>
                                    <li>Lawyer representing the immediate family *</li>
                                    <li>A bank, executor of the estate, insurance company, or anyone requiring a certificate to pay a policy or death benefit on the decedent *</li>
                                    <li>In some cases, individuals or organizations may be authorized to obtain a certificate when determining a personal or property right *</li>
                                </ul>
                            </v-col>
                            <v-col cols="12">
                                <i>* The applicant must demonstrate the requirement for the certificate</i>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </v-col>
            <v-divider></v-divider>
            <v-col cols="12">
                <button class="text-only" style="color:blue; font-size:x-large;" @click="redirectToMarriage()">Order Marriage Certificate </button><v-icon large @click="redirectToMarriage()">mdi-account-multiple-plus</v-icon><br>
                <b>REQUESTS — WHO MAY HAVE COPIES:<v-icon @click="showMarriageDiv = !showMarriageDiv">mdi-chevron-down</v-icon></b>
                <div v-if="showMarriageDiv">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                Vital records are considered confidential information and closed to the general public until one hundred (100) years after the date of birth or fifty (50) years after the date of marriage, divorce, or death. Generally, only those listed on the record are entitled to receive certified copies, though there are exceptions. Please refer to our website for more information on possible exceptions.
                                Individuals entitled to received certified copies of vital records are as follows:
                            </v-col>
                            <v-col cols="12">
                                <ul>
                                    <li>Either party named on the certificate</li>
                                    <li>Lawyer representing either party</li>
                                </ul>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </v-col>
            <v-divider></v-divider>
            <v-col cols="12">
                <button class="text-only" style="color:blue; font-size:x-large;" @click="redirectToDivorce()">Order Divorce Certificate </button><v-icon large @click="redirectToDivorce()">mdi-account-multiple-minus</v-icon><br>
                <b>REQUESTS — WHO MAY HAVE COPIES:<v-icon @click="showDivorceDiv = !showDivorceDiv">mdi-chevron-down</v-icon></b>
                <div v-if="showDivorceDiv">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                Vital records are considered confidential information and closed to the general public until one hundred (100) years after the date of birth or fifty (50) years after the date of marriage, divorce, or death. Generally, only those listed on the record are entitled to receive certified copies, though there are exceptions. Please refer to our website for more information on possible exceptions.
                                Individuals entitled to received certified copies of vital records are as follows:
                            </v-col>
                            <v-col cols="12">
                                <ul>
                                    <li>Either party named on the certificate</li>
                                    <li>Lawyer representing either party</li>
                                </ul>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

export default {
    components: {
    },
    data: () => {
        return {
            showBirthDiv: false,
            showDeathDiv: false,
            showMarriageDiv: false,
            showDivorceDiv: false
        }
    },
    methods: {
        redirectToBirth () {
            this.$router.push('order-birth-certificate')
        },
        redirectToDeath () {
            this.$router.push('order-death-certificate')
        },
        redirectToMarriage () {
            this.$router.push('order-marriage-certificate')
        },
        redirectToDivorce () {
            this.$router.push('order-divorce-certificate')
        }
    }
}
</script>
